import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelSelect as _vModelSelect, vShow as _vShow, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16" }
const _hoisted_4 = { class: "font-poppins" }
const _hoisted_5 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 gap-x-10 font-poppins" }
const _hoisted_6 = { class: "mt-1 flex" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mt-1 flex" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = { class: "mt-1 flex" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "sm:col-span-2 mt-4" }
const _hoisted_17 = { class: "mt-1 flex relative" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "mt-1" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "mt-1 flex" }
const _hoisted_26 = ["min", "disabled"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "mt-4 font-poppins"
}
const _hoisted_29 = { class: "mt-1 flex" }
const _hoisted_30 = ["max", "disabled"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "mt-1 flex" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "mt-6 flex space-x-2" }
const _hoisted_36 = { class: "flex items-center h-5" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 1,
  class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 gap-x-10 font-poppins"
}
const _hoisted_39 = { class: "mt-1" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "mt-1 flex" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "mt-10 lg:mt-0" }
const _hoisted_46 = { class: "font-poppins" }
const _hoisted_47 = { class: "mt-4 bg-white" }
const _hoisted_48 = { class: "py-6 px-4 space-y-6 sm:px-6" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "min-w-0 flex-1" }
const _hoisted_51 = { class: "text-lg py-0 my-0" }
const _hoisted_52 = { class: "text-base font-medium text-gray-900" }
const _hoisted_53 = { class: "text-md font-light pr-6" }
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "text-base font-medium text-gray-900" }
const _hoisted_56 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "text-base font-medium text-gray-900" }
const _hoisted_59 = {
  key: 1,
  class: "flex items-center justify-between border-t border-gray-200 pt-6"
}
const _hoisted_60 = { class: "text-sm font-light h-64 overflow-hidden" }
const _hoisted_61 = { class: "text-md font-light pr-6" }
const _hoisted_62 = ["href"]
const _hoisted_63 = { class: "text-base font-medium text-gray-900" }
const _hoisted_64 = { class: "text-md font-light pr-6" }
const _hoisted_65 = ["href"]
const _hoisted_66 = { class: "text-base font-medium text-gray-900" }
const _hoisted_67 = { class: "text-md font-light pr-6" }
const _hoisted_68 = ["href"]
const _hoisted_69 = { class: "text-base font-medium text-gray-900" }
const _hoisted_70 = {
  key: 0,
  class: "items-end flex flex-col justify-end text-right pr-6"
}
const _hoisted_71 = {
  key: 0,
  class: "mt-4 text-sm text-red-600"
}
const _hoisted_72 = {
  key: 1,
  class: "items-end flex justify-end w-full text-right"
}
const _hoisted_73 = { class: "text-left col-start-1 col-span-2 flex flex-col" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  key: 1,
  class: "text-left py-4"
}
const _hoisted_76 = { class: "hidden md:block text-right col-span-1 col-start-3" }
const _hoisted_77 = {
  key: 1,
  class: "lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16"
}
const _hoisted_78 = { class: "border-t border-gray-200 pt-6" }
const _hoisted_79 = {
  key: 0,
  class: "mt-6 font-poppins"
}
const _hoisted_80 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_83 = { class: "text-sm text-red-600" }
const _hoisted_84 = {
  key: 3,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_85 = {
  key: 1,
  class: "mt-6 grid grid-cols-4 gap-y-6 gap-x-4 font-poppins"
}
const _hoisted_86 = { class: "col-span-4" }
const _hoisted_87 = { class: "mt-1 flex" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "col-span-3" }
const _hoisted_90 = { class: "mt-1 flex" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { class: "mt-1 flex" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { class: "mt-10 lg:mt-0" }
const _hoisted_95 = { class: "mt-4 bg-white font-poppins" }
const _hoisted_96 = { class: "py-6 flex flex-col md:flex-row items-end justify-end" }
const _hoisted_97 = { class: "w-full" }
const _hoisted_98 = {
  key: 0,
  class: "mt-4 text-sm text-red-600"
}
const _hoisted_99 = {
  key: 1,
  class: "mt-4 text-sm text-red-600"
}

import { computed, reactive, ref, watch, nextTick, onMounted, onUnmounted } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { helpers, email, required, requiredIf, minLength, maxLength, integer } from '@vuelidate/validators';
import { nameValidations } from '@/validations/nameValidations';
import { OrderServiceInterface } from '@/services/orderServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Product } from '@/adapters/catalogAdapterInterface';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import AsyncButton from '../library/AsyncButton.vue';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Carrier } from '@/services/integration/enums';
import { MonoovaTokenProviderInterface } from '@/services/integration/clients/monoova/monoovaTokenProviderInterface';
import { mountCardCheckout, extractCardScheme, CardCheckoutHandle, PrimerCheckoutPayment } from '@/services/integration/clients/monoova/monoovaCheckout';
import format from 'date-fns/format';
import addDays from 'date-fns/fp/addDays';
import store from '@/store';
import { CheckCircleIcon } from '@heroicons/vue/solid';
import { RecaptchaV2, useRecaptcha } from 'vue3-recaptcha-v2';
import OtpVerification from '@/components/ordering/OtpVerification.vue';

// Adding this prevents Vue warnings
import { Switch } from '@headlessui/vue';
import { Action, Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';
import CsgTerms from '@/components/content/CsgTerms.vue';
import StepGuide from './StepGuide.vue';
import { LoadedCartCustomer } from '@/utils/cartLoader';
import OrderSummary from './OrderSummary.vue';

export type ContactInformation = {
  firstName: string | null,
  lastName: string | null,
  phoneNumber: string | null,
  email: string,
  activationDate: string
};

type Service = {
  id: string,
  address: string,
  carrier: string,
  locationId: string,
  requiresNewDevelopmentCost: boolean,
  development: string,
  suburb: string,
  state: string,
  rtcDays: number,
}

type ConfirmOrderData = {
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: number | null,
  companyName: string,
  abnNumber: number | null,
  ccNumber: number | null,
  ccName: string,
  ccExpiry: string,
  ccCvc: string,
  ccMonoovaToken?: string,
  ccMonoovaScheme?: string,
  ddAccountName: string,
  ddAccountNumber: string,
  ddAccountBsb: string,
  token?: string,
  activationDate: string,
  formSelectionOptions: {
    businessAccount: boolean,
    paymentMethod: string,
    confirmAddressToggle: boolean,
    termsAgreementToggle: boolean,
    privacyToggle: boolean,
    additionalFeesToggle: boolean,
    csgWaiverToggle: boolean,
    toggleExpandCsgWaiver: boolean,
    ddAgreementToggle: boolean,
    pickActivationDate: boolean
  },
  captchaValid: boolean,
  birthdate?: string | null,
  licenseId?: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderForm',
  props: {
    errors: {},
    products: {},
    service: {},
    isPromoValid: { type: Boolean },
    promotionDiscounts: {},
    validPromotion: {},
    suggestedPromotion: {},
    promoCode: {},
    initialCustomer: {},
    otpStep: {}
  },
  emits: ["onEnterPromoCode", "onConfirmOrder", "onConfirmContact", "onContactInformation", "onOtpVerified", "closeOtp"],
  setup(__props: any, { emit: __emit }) {

const orderService = injectStrict<OrderServiceInterface>('OrderServiceInterface');
const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const monoovaTokenProvider = injectStrict<MonoovaTokenProviderInterface>('MonoovaTokenProviderInterface');

const props = __props;

const account = computed(() => {
  return store.state.account;
});

const salesPerson = computed(() => {
  return store.state.salesPerson;
});

const isPromoValid = computed(() => {
  return props.isPromoValid;
});

const voiceProduct = computed(() => {
  return props.products.filter(product => product.type === 'voice').length > 0;
});

const today = computed((): string => {
  return format(new Date(), 'yyyy-MM-dd');
});

const tomorrow = computed((): string => {
  return format(addDays(1, new Date()), 'yyyy-MM-dd');
});

const min18 = computed((): string => {
  const td = new Date();
  return format(td.setFullYear(td.getFullYear() - 18), 'yyyy-MM-dd');
});

const verified = ref(false);

const formData : ConfirmOrderData = reactive({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: null,
  companyName: '',
  abnNumber: null,
  ccNumber: null,
  ccName: '',
  ccExpiry: '',
  ccCvc: '',
  ccMonoovaToken: '',
  ccMonoovaScheme: '',
  ddAccountName: '',
  ddAccountNumber: '',
  ddAccountBsb: '',
  token: '',
  crmId: null,
  activationDate: today.value,
  formSelectionOptions: {
    businessAccount: false,
    paymentMethod: 'cc',
    confirmAddressToggle: false,
    termsAgreementToggle: false,
    privacyToggle: false,
    additionalFeesToggle: false,
    csgWaiverToggle: false,
    toggleExpandCsgWaiver: false,
    ddAgreementToggle: false,
    pickActivationDate: false
  },
  captchaValid: false,
  birthdate: '',
  licenseId: ''
});

const { handleReset } = useRecaptcha();

const handleWidgetId = (widgetId: number) => {
  handleReset(widgetId);
};
const handleErrorCalback = () => {
  formData.captchaValid = false;
};
const handleExpiredCallback = () => {
  formData.captchaValid = false;
};
const handleLoadCallback = (response: unknown) => {
  if (response) {
    formData.captchaValid = true;
  }
};

const contactInformation : ContactInformation = reactive({
  firstName: null,
  lastName: null,
  phoneNumber: null,
  email: '',
  activationDate: ''
});

// Pre-fill the details from a cart being edited (?cartId=).
if (props.initialCustomer) {
  const customer = props.initialCustomer;
  formData.firstName = customer.firstName;
  formData.lastName = customer.lastName;
  formData.email = customer.email;
  // Kept as a string so a leading 0 isn't lost, same as typing into the input.
  formData.phoneNumber = (customer.phoneNumber || null) as unknown as number | null;
  formData.birthdate = customer.birthdate;
  formData.licenseId = customer.licenseId;

  if (customer.companyName || customer.abnNumber) {
    formData.formSelectionOptions.businessAccount = true;
    formData.companyName = customer.companyName;
    formData.abnNumber = (customer.abnNumber || null) as unknown as number | null;
  }

  // A past activation date falls back to the default of today.
  if (customer.activationDate && customer.activationDate > today.value) {
    formData.formSelectionOptions.pickActivationDate = true;
    formData.activationDate = customer.activationDate;
  }

  contactInformation.firstName = formData.firstName || null;
  contactInformation.lastName = formData.lastName || null;
  contactInformation.phoneNumber = customer.phoneNumber || null;
  contactInformation.email = formData.email;
  contactInformation.activationDate = formData.activationDate;
}

const pickActivationDate = ref(() => formData.formSelectionOptions.pickActivationDate);
const businessAccount = ref(() => formData.formSelectionOptions.businessAccount);
const paymentMethodRequiredDd = ref(() => formData.formSelectionOptions.paymentMethod === 'dd' && (!salesPerson.value));
const bdayRequired = ref(() => orderService.calculateMinimumCost(props.products, props.isPromoValid, props.validPromotion) >= 1000);

const rules = {
  firstName: {
    required: helpers.withMessage('Please enter a firstname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  lastName: {
    required: helpers.withMessage('Please enter a lastname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  email: {
    required: helpers.withMessage('Please enter an email address', required),
    email: helpers.withMessage('Please enter a valid email address', email)
  },
  phoneNumber: {
    required: helpers.withMessage('This field cannot be empty', required),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(10)),
    maxLengthValue: helpers.withMessage('Please enter a phone number with 10 digits', maxLength(10))
  },
  companyName: {
    requiredIf: helpers.withMessage('Please enter a company name', requiredIf(businessAccount.value)),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(1)),
    maxLengthValue: helpers.withMessage('Please enter less than 50 chars', maxLength(50)),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation)
  },
  abnNumber: {
    requiredIf: helpers.withMessage('Please enter an ABN number', requiredIf(businessAccount.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 11 digit ABN number', minLength(11)),
    maxLength: helpers.withMessage('Please enter a 11 digit ABN number', maxLength(11))
  },
  ddAccountName: {
    requiredIf: helpers.withMessage('Please enter an account name', requiredIf(paymentMethodRequiredDd.value)),
    minLength: helpers.withMessage('Please enter a valid account name', minLength(2))
  },
  ddAccountNumber: {
    requiredIf: helpers.withMessage('Please enter an account number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a valid account number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a valid account number', maxLength(10))
  },
  ddAccountBsb: {
    requiredIf: helpers.withMessage('Please enter a BSB number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 6 digit BSB number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a 6 digit BSB number', maxLength(6))
  },
  activationDate: {
    requiredIf: helpers.withMessage('Please select a date the service should be activated', requiredIf(pickActivationDate.value))
  },
  birthdate: {
    requiredIf: helpers.withMessage('Please enter your birthdate', requiredIf(bdayRequired.value))
  }
};
const v$ = useVuelidate(rules, formData);

const directDebitFormFields = computed(() => {
  return formData.formSelectionOptions.paymentMethod !== 'cc';
});

// eslint-disable-next-line func-call-spacing
const emit = __emit;

// True once "Confirm Contact Information" has been clicked at least once - the agreement
// errors below only show once an attempt has actually been made, and stay in sync with the
// toggles live from then on (no separate per-toggle "clear the error" handler needed).
const contactAgreementsAttempted = ref(false);
const confirmAddressError = computed(() => contactAgreementsAttempted.value && !formData.formSelectionOptions.confirmAddressToggle);
const termsAgreementError = computed(() => contactAgreementsAttempted.value && !formData.formSelectionOptions.termsAgreementToggle);
const ddAgreementError = computed(() => contactAgreementsAttempted.value && !formData.formSelectionOptions.ddAgreementToggle);
const privacyError = computed(() => contactAgreementsAttempted.value && !formData.formSelectionOptions.privacyToggle);
const isNbnService = computed(() => props.service.carrier === Carrier.NB);
const additionalFeesError = computed(() => contactAgreementsAttempted.value && isNbnService.value && !formData.formSelectionOptions.additionalFeesToggle);
// Only bind https links on the brand assets host to :href - anything else (javascript:, other
// origins) falls back to the default CIS so the link can't be used for XSS.
const cisUrl = computed(() => {
  const assetsBaseUrl = brandService.getAssetsBaseUrl();
  const fallback = `${assetsBaseUrl}/${brandService.getName()}/critical-information-summary-internet.pdf`;
  const link = brandService.getPlanSelectorProductInformation(props.service.carrier).standardLinks
    .find(standardLink => standardLink.name === 'Critical Information Summary')?.link;
  if (!link) return fallback;
  try {
    const url = new URL(link);
    return url.protocol === 'https:' && url.origin === new URL(assetsBaseUrl).origin ? url.href : fallback;
  } catch {
    return fallback;
  }
});
const csgWaiverError = computed(() => contactAgreementsAttempted.value && voiceProduct.value && !formData.formSelectionOptions.csgWaiverToggle);
const captchaError = ref(false);

const cardEntryError = ref(false);

const monoovaContainer = ref<HTMLElement | null>(null);
const monoovaLoading = ref(false);
const monoovaSessionActive = ref(false);
const monoovaError = ref('');
const cardCheckoutComplete = ref(false);
const cardCheckoutHandle = ref<CardCheckoutHandle | null>(null);
const cardSubmittable = ref(false);
const pendingConfirmOrderDone = ref<(() => void) | null>(null);

const monoovaReady = computed(() => {
  return Boolean(formData.firstName && formData.lastName && formData.email);
});

const ensureMonoovaCheckout = async () => {
  if (monoovaSessionActive.value || monoovaLoading.value || !monoovaReady.value) {
    return;
  }

  const container = monoovaContainer.value;
  if (!container) {
    return;
  }

  container.innerHTML = '';
  monoovaLoading.value = true;
  monoovaError.value = '';
  cardEntryError.value = false;
  cardCheckoutComplete.value = false;
  cardCheckoutHandle.value = null;
  cardSubmittable.value = false;
  formData.ccMonoovaToken = '';
  formData.ccMonoovaScheme = '';

  try {
    // The btbToken is available as soon as the client token is generated -
    // it does not mean the customer has completed entering their card.
    // cardCheckoutComplete (set in onComplete below) tracks that instead.
    const response = await monoovaTokenProvider.generateClientToken(brandService.getName(), {
      emailAddress: formData.email,
      firstName: formData.firstName,
      lastName: formData.lastName
    });

    formData.ccMonoovaToken = response.btbToken;

    // Card authorisation is triggered by the shared "Confirm Order" button (see
    // handleConfirmOrder) rather than a submit button inside the widget itself.
    cardCheckoutHandle.value = await mountCardCheckout(response.clientToken, container, {
      onSubmittableChange: (submittable) => {
        cardSubmittable.value = submittable;
      },
      onComplete: (payment: PrimerCheckoutPayment) => {
        formData.ccMonoovaScheme = extractCardScheme(payment);
        cardCheckoutComplete.value = true;
        resolvePendingConfirmOrder(true);
      },
      onFail: () => {
        monoovaSessionActive.value = false;
        cardCheckoutComplete.value = false;
        formData.ccMonoovaToken = '';
        monoovaError.value = 'We are unable to process your credit card. Please double-check all card details are correct. If the issue persists, please contact your card issuer or try an alternative payment method.';
        resolvePendingConfirmOrder(false);
      }
    });

    monoovaSessionActive.value = true;
  } catch (e) {
    console.error(e);
    monoovaError.value = 'Unable to load the secure payment form. Please try again later.';
  } finally {
    monoovaLoading.value = false;
  }
};

const retryMonoovaCheckout = () => {
  monoovaSessionActive.value = false;
  cardCheckoutComplete.value = false;
  monoovaError.value = '';
  ensureMonoovaCheckout();
};

watch(() => formData.formSelectionOptions.paymentMethod, (paymentMethod) => {
  if (paymentMethod !== 'cc') {
    monoovaSessionActive.value = false;
    cardCheckoutComplete.value = false;
    cardCheckoutHandle.value = null;
    cardSubmittable.value = false;
    monoovaError.value = '';
    cardEntryError.value = false;
    formData.ccMonoovaToken = '';
    formData.ccMonoovaScheme = '';
    if (monoovaContainer.value) {
      monoovaContainer.value.innerHTML = '';
    }
  }
});

const contactRules = {
  firstName: rules.firstName,
  lastName: rules.lastName,
  email: rules.email,
  phoneNumber: rules.phoneNumber,
  activationDate: rules.activationDate
};

const vContact$ = useVuelidate(contactRules, contactInformation);

const handleContactInformation = async (done: () => void) => {
  const contactFormValidated = await vContact$.value.$validate();
  contactAgreementsAttempted.value = true;

  // birthdate lives on formData (validated by v$, not vContact$) but is shown in this same
  // Contact Information section, so it needs to be checked here too - otherwise a skipped
  // credit-check field wasn't caught until Confirm Order, by which point the card had
  // already been authorised. licenseId on the same section is optional, so it's untouched.
  // Only actually validate it when the credit-check block (and the field itself) is visible -
  // below the $1000 threshold it's hidden and must not block submission.
  if (bdayRequired.value()) {
    v$.value.birthdate.$touch();
  }
  const creditCheckFieldsValid = !bdayRequired.value() || !v$.value.birthdate.$error;

  const agreementsValid = !confirmAddressError.value && !termsAgreementError.value && !ddAgreementError.value &&
    !privacyError.value && !additionalFeesError.value && !csgWaiverError.value;

  if (!contactFormValidated || !agreementsValid || !creditCheckFieldsValid) {
    done();
    return;
  }
  emit('onConfirmContact', contactInformation, done);
};

// Terms/address/privacy/dd/csg agreements are validated up-front in handleContactInformation
// above, so this is purely the trigger for card or bank account submission from here on.
const handleConfirmOrder = async (done: () => void) => {
  const formValidated = await v$.value.$validate();

  // True once the customer still needs to authorise their card - i.e. paying by card and
  // the widget hasn't already completed a successful authorisation for this session.
  const cardNotYetAuthorised = formData.formSelectionOptions.paymentMethod === 'cc' && !cardCheckoutComplete.value;
  cardEntryError.value = cardNotYetAuthorised && !(cardCheckoutHandle.value && cardSubmittable.value);

  if (!formValidated || cardEntryError.value) {
    done();
    return;
  }

  if (cardNotYetAuthorised) {
    // Card authorisation happens inside the embedded Monoova/Primer widget - trigger it here
    // and wait for onComplete/onFail (see ensureMonoovaCheckout) to resolve this, via
    // resolvePendingConfirmOrder, before the order is actually submitted.
    pendingConfirmOrderDone.value = done;
    cardCheckoutHandle.value?.submit();
    return;
  }

  emit('onConfirmOrder', formData, done);
};

const resolvePendingConfirmOrder = (cardAuthorisationSucceeded: boolean) => {
  const done = pendingConfirmOrderDone.value;
  if (!done) {
    return;
  }

  pendingConfirmOrderDone.value = null;

  if (cardAuthorisationSucceeded) {
    // Re-run validation/submission now that cardCheckoutComplete is true - it will
    // proceed straight to emitting the order rather than re-triggering card auth.
    handleConfirmOrder(done);
  } else {
    done();
  }
};

const handleClickBusinessAccount = () => {
  formData.companyName = '';
  formData.abnNumber = null;
};

const handleActivationDate = () => {
  if (formData.formSelectionOptions.pickActivationDate) {
    formData.activationDate = tomorrow.value;
    contactInformation.activationDate = tomorrow.value;
  } else {
    formData.activationDate = today.value;
    contactInformation.activationDate = today.value;
  }
};

const handleFirstNameBlur = () => {
  v$.value.firstName.$touch();

  if (!v$.value.firstName.$error) {
    contactInformation.firstName = formData.firstName;
  } else {
    contactInformation.firstName = null;
  }
};

const handleLastNameBlur = () => {
  v$.value.lastName.$touch();

  if (!v$.value.lastName.$error) {
    contactInformation.lastName = formData.lastName;
  } else {
    contactInformation.lastName = null;
  }
};

const handlePhoneBlur = () => {
  v$.value.phoneNumber.$touch();

  if (!v$.value.phoneNumber.$error) {
    contactInformation.phoneNumber = formData.phoneNumber;
  } else {
    contactInformation.phoneNumber = null;
  }
};

const handleEmailBlur = () => {
  v$.value.email.$touch();

  if (!v$.value.email.$error) {
    contactInformation.email = formData.email;
  } else {
    contactInformation.email = null;
  }
};

const handleVerified = (data: unknown) => {
  console.log('OTP verified:', data);

  emit('onOtpVerified');

  verified.value = true;
};

// AsyncButton shows a loading state until done() is called.
const editDetails = (done: () => void) => {
  verified.value = false;
  // Back to the start so confirming again goes through OTP/payment afresh.
  closeOtp();
  done();
};

const toggleExpandCsgWaiver = () => {
  formData.formSelectionOptions.toggleExpandCsgWaiver = !formData.formSelectionOptions.toggleExpandCsgWaiver;
};

const paymentStep = ref<HTMLElement | null>(null);

watch(verified, async (ver) => {
  if (ver) { // LAST STEP
    await nextTick();

    paymentStep.value?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});

watch(
  contactInformation,
  (newContactInformation) => {
    if (newContactInformation.email) {
      emit('onContactInformation', newContactInformation);
    }
  }
);

const otpStepRef = ref<HTMLElement | null>(null);

const showOtp = ref(false);

const modalRef = ref<HTMLElement | null>(null);

/* ---------------------------
   OPEN / CLOSE
---------------------------- */
const openOtp = () => {
  showOtp.value = true;
};

const closeOtp = () => {
  emit('closeOtp');
};

watch(
  () => props.otpStep,
  async (newStep) => {
    if (newStep === 3) {
      // Payment step, also reached directly when the phone was already verified.
      verified.value = true;
    }

    if (newStep === 2) {
      await nextTick();

      document.body.style.overflow = 'hidden';
      modalRef.value?.focus?.();
    } else {
      document.body.style.overflow = '';
    }
  }
);

/* ---------------------------
   ESC TO CLOSE
---------------------------- */
const handleKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    closeOtp();
  }
};

onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[74] || (_cache[74] = _createElementVNode("h2", { class: "sr-only" }, "Checkout", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _cache[43] || (_cache[43] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Contact information", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _cache[30] || (_cache[30] = _createElementVNode("label", {
                  for: "first-name",
                  class: "block text-sm font-bold text-black"
                }, "First name", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "first-name",
                    name: "first-name",
                    autocomplete: "given-name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.firstName) = $event)),
                    onBlur: handleFirstNameBlur,
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                    disabled: verified.value
                  }, null, 40, _hoisted_7), [
                    [_vModelText, formData.firstName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vContact$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "firstName-error"
                  }, [
                    (error.$property === 'firstName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _cache[31] || (_cache[31] = _createElementVNode("label", {
                  for: "last-name",
                  class: "block text-sm font-bold text-black"
                }, "Last name", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "last-name",
                    name: "last-name",
                    autocomplete: "family-name",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.lastName) = $event)),
                    onBlur: handleLastNameBlur,
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                    disabled: verified.value
                  }, null, 40, _hoisted_10), [
                    [_vModelText, formData.lastName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vContact$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "lastName-error"
                  }, [
                    (error.$property === 'lastName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[32] || (_cache[32] = _createElementVNode("label", {
                for: "email-address",
                class: "block text-sm font-bold text-black"
              }, "Email address", -1)),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  id: "email-address",
                  name: "email-address",
                  autocomplete: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.email) = $event)),
                  onBlur: handleEmailBlur,
                  class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                  disabled: verified.value
                }, null, 40, _hoisted_14), [
                  [_vModelText, formData.email]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vContact$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "email-error"
                }, [
                  (error.$property === 'email')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                for: "phone",
                class: "block text-sm font-bold text-black"
              }, "Phone", -1)),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "phone",
                  id: "phone",
                  autocomplete: "tel",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.phoneNumber) = $event)),
                  onBlur: handlePhoneBlur,
                  class: _normalizeClass([
                  'w-full border rounded px-3 py-2 pr-10 transition',
                  verified.value
                    ? 'bg-green-50 border-green-500 text-green-700 cursor-not-allowed rounded-full'
                    : 'block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none'
                ]),
                  disabled: verified.value
                }, null, 42, _hoisted_18), [
                  [_vModelText, formData.phoneNumber]
                ]),
                (verified.value)
                  ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                      key: 0,
                      class: "w-5 h-5 text-green-600 absolute right-3 top-1/2 -translate-y-1/2"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vContact$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "phoneNumber-error"
                }, [
                  (error.$property === 'phoneNumber')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[35] || (_cache[35] = _createElementVNode("label", {
                  for: "activationDateOption",
                  class: "block text-sm font-bold text-black"
                }, "Service activation date", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("select", {
                    id: "activationDateOption",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.formSelectionOptions.pickActivationDate) = $event)),
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                    disabled: verified.value,
                    onChange: handleActivationDate
                  }, _cache[34] || (_cache[34] = [
                    _createElementVNode("option", { value: false }, "ASAP", -1),
                    _createElementVNode("option", { value: true }, "Pick a Date", -1)
                  ]), 40, _hoisted_23), [
                    [_vModelSelect, formData.formSelectionOptions.pickActivationDate]
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_24, [
                _cache[36] || (_cache[36] = _createElementVNode("label", {
                  for: "activationDate",
                  class: "block text-sm font-bold text-black"
                }, "Confirm service activation date", -1)),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    min: tomorrow.value,
                    name: "activationDate",
                    id: "activationDate",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.activationDate) = $event)),
                    onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(v$).activationDate.$touch && _unref(v$).activationDate.$touch(...args))),
                    class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                    disabled: verified.value
                  }, null, 40, _hoisted_26), [
                    [_vModelText, formData.activationDate]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "activationDate-error"
                  }, [
                    (error.$property === 'activationDate')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512), [
                [_vShow, formData.formSelectionOptions.pickActivationDate]
              ])
            ]),
            (_unref(orderService).calculateMinimumCost(_ctx.products, isPromoValid.value, _ctx.validPromotion) >= 1000)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-sm text-black font-poppins tracking-tight pt-0 py-0 my-0" }, "Based on the total value of your order, and in accordance with our obligations under the 2019 TCP Code, Nexee is required to run an external credit check before we can confirm your order. This may delay your service activation as it is dependent on the credit check being completed first.", -1)),
                  _cache[38] || (_cache[38] = _createElementVNode("label", {
                    for: "birthdate",
                    class: "block text-sm font-bold text-black font-poppins pt-4"
                  }, "Birthdate", -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      max: min18.value,
                      name: "birthdate",
                      id: "birthdate",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.birthdate) = $event)),
                      onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(v$).birthdate.$touch && _unref(v$).birthdate.$touch(...args))),
                      class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                      disabled: verified.value
                    }, null, 40, _hoisted_30), [
                      [_vModelText, formData.birthdate]
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "mt-2 text-sm text-red-600",
                      id: "bday-error"
                    }, [
                      (error.$property === 'birthdate')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(error.$message), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _cache[39] || (_cache[39] = _createElementVNode("label", {
                    for: "License Id",
                    class: "block text-sm font-bold text-black font-poppins pt-4"
                  }, "License Id", -1)),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "licenseId",
                      name: "licenseId",
                      autocomplete: "licenseId",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.licenseId) = $event)),
                      class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                      disabled: verified.value
                    }, null, 8, _hoisted_33), [
                      [_vModelText, formData.licenseId]
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "mt-2 text-sm text-red-600",
                      id: "licenseid-error"
                    }, [
                      (error.$property === 'licenseId')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(error.$message), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _withDirectives(_createElementVNode("input", {
                  onClick: handleClickBusinessAccount,
                  id: "same-as-shipping",
                  name: "same-as-shipping",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.formSelectionOptions.businessAccount) = $event)),
                  class: "h-4 w-4 border-black border-solid border-1 rounded text-black focus:ring-brand-primary",
                  disabled: verified.value
                }, null, 8, _hoisted_37), [
                  [_vModelCheckbox, formData.formSelectionOptions.businessAccount]
                ])
              ]),
              _cache[40] || (_cache[40] = _createElementVNode("label", {
                for: "same-as-shipping",
                class: "text-sm font-bold text-gray-900"
              }, "Is this a business account?", -1))
            ]),
            (formData.formSelectionOptions.businessAccount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", null, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", {
                      for: "company-name",
                      class: "block text-sm font-bold text-black"
                    }, "Company name", -1)),
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "company-name",
                        name: "company-name",
                        autocomplete: "organization",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.companyName) = $event)),
                        onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_unref(v$).companyName.$touch && _unref(v$).companyName.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                        disabled: verified.value
                      }, null, 40, _hoisted_40), [
                        [_vModelText, formData.companyName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "companyName-error"
                      }, [
                        (error.$property === 'companyName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", {
                      for: "abn-number",
                      class: "block text-sm font-bold text-black"
                    }, "ABN Number", -1)),
                    _createElementVNode("div", _hoisted_42, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "abn-number",
                        name: "abn-number",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.abnNumber) = $event)),
                        onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(v$).abnNumber.$touch && _unref(v$).abnNumber.$touch(...args))),
                        class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                        disabled: verified.value
                      }, null, 40, _hoisted_43), [
                        [_vModelText, formData.abnNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "abnNumber-error"
                      }, [
                        (error.$property === 'abnNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _cache[58] || (_cache[58] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Confirm Details", -1)),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-6", [formData.formSelectionOptions.confirmAddressToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-2xl font-light py-0 my-0" }, " My address is: ", -1)),
                      _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.service.address), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_unref(Switch), {
                      modelValue: formData.formSelectionOptions.confirmAddressToggle,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.formSelectionOptions.confirmAddressToggle) = $event)),
                      disabled: verified.value,
                      class: _normalizeClass([
                        (formData.formSelectionOptions.confirmAddressToggle ? 'bg-white' : 'bg-gray-300'),
                        (verified.value ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full transition-colors ease-in-out duration-200 my-0 py-0'),
                        (confirmAddressError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[45] || (_cache[45] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [45]
                    }, 8, ["modelValue", "disabled", "class"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.termsAgreementToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_53, [
                    _cache[46] || (_cache[46] = _createTextVNode(" I have read, understood and accept the ")),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/customer-service-agreement.pdf`,
                      target: "_blank",
                      class: _normalizeClass(["hover:underline transition duration-250 font-bold", [formData.formSelectionOptions.termsAgreementToggle ? 'text-white' : 'text-black']])
                    }, "Terms and Conditions.", 10, _hoisted_54)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_unref(Switch), {
                      modelValue: formData.formSelectionOptions.termsAgreementToggle,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.formSelectionOptions.termsAgreementToggle) = $event)),
                      disabled: verified.value,
                      class: _normalizeClass([
                        (formData.formSelectionOptions.termsAgreementToggle ? 'bg-white' : 'bg-gray-300'),
                        (verified.value ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full transition-colors ease-in-out duration-200 my-0 py-0'),
                        (termsAgreementError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[47] || (_cache[47] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [47]
                    }, 8, ["modelValue", "disabled", "class"])
                  ])
                ], 2),
                (voiceProduct.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.csgWaiverToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                    }, [
                      _createElementVNode("div", {
                        class: "text-md font-light",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (toggleExpandCsgWaiver()))
                      }, [
                        _cache[49] || (_cache[49] = _createTextVNode(" I have read, understood and accept the ")),
                        _createElementVNode("span", {
                          class: _normalizeClass(["underline transition duration-250 font-bold", [formData.formSelectionOptions.csgWaiverToggle ? 'text-white' : 'text-black']])
                        }, "CSG waiver.", 2),
                        (formData.formSelectionOptions.csgWaiverToggle && salesPerson.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_56, [
                              _cache[48] || (_cache[48] = _createTextVNode("Ensure you have read the ")),
                              _createElementVNode("a", {
                                class: "text-red-600",
                                href: _ctx.$router.resolve({ name: 'csg-waiver-script' }).href,
                                target: "_blank"
                              }, "CSG Waiver Script", 8, _hoisted_57)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_unref(Switch), {
                          modelValue: formData.formSelectionOptions.csgWaiverToggle,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.formSelectionOptions.csgWaiverToggle) = $event)),
                          disabled: verified.value,
                          class: _normalizeClass([
                        (formData.formSelectionOptions.csgWaiverToggle ?  'bg-white' : 'bg-gray-300'),
                        (verified.value ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full transition-colors ease-in-out duration-200 my-0 py-0'),
                        (csgWaiverError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                        }, {
                          default: _withCtx(() => [
                            _cache[50] || (_cache[50] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                                "aria-hidden": "true"
                              }, null, 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                                "aria-hidden": "true"
                              }, null, 2)
                            ], 2)
                          ]),
                          _: 1,
                          __: [50]
                        }, 8, ["modelValue", "disabled", "class"])
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (voiceProduct.value && formData.formSelectionOptions.toggleExpandCsgWaiver)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(CsgTerms, {
                          firstName: contactInformation.firstName,
                          lastName: contactInformation.lastName,
                          brand: _unref(brandService).getTitle(),
                          phone: _unref(brandService).getSupportPhoneNumber(),
                          address: _unref(brandService).getAddress()
                        }, null, 8, ["firstName", "lastName", "brand", "phone", "address"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.ddAgreementToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_61, [
                    _cache[51] || (_cache[51] = _createTextVNode(" I have read, understood and accept the ")),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/direct-debit-service-request-agreement.pdf`,
                      target: "_blank",
                      class: _normalizeClass(["underline transition duration-250 font-bold", [formData.formSelectionOptions.ddAgreementToggle ? 'text-white' : 'text-black']])
                    }, "Direct Debit Service Request Agreement.", 10, _hoisted_62)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_unref(Switch), {
                      modelValue: formData.formSelectionOptions.ddAgreementToggle,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.formSelectionOptions.ddAgreementToggle) = $event)),
                      disabled: verified.value,
                      class: _normalizeClass([
                        (formData.formSelectionOptions.ddAgreementToggle ?  'bg-white' : 'bg-gray-300'),
                        (verified.value ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full transition-colors ease-in-out duration-200 my-0 py-0'),
                        (ddAgreementError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [52]
                    }, 8, ["modelValue", "disabled", "class"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.privacyToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                }, [
                  _createElementVNode("div", _hoisted_64, [
                    _createTextVNode(" I consent to " + _toDisplayString(_unref(brandService).getTitle()) + " collecting, using, storing and disclosing my personal information in accordance with the " + _toDisplayString(_unref(brandService).getTitle()) + " Privacy Policy. I have read, understood and agree to comply with the " + _toDisplayString(_unref(brandService).getTitle()) + " ", 1),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/privacy-policy.pdf`,
                      target: "_blank",
                      class: "underline transition duration-250 font-bold text-black"
                    }, "Privacy Policy", 8, _hoisted_65),
                    _cache[53] || (_cache[53] = _createTextVNode(". "))
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_unref(Switch), {
                      modelValue: formData.formSelectionOptions.privacyToggle,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.formSelectionOptions.privacyToggle) = $event)),
                      disabled: verified.value,
                      class: _normalizeClass([
                        (formData.formSelectionOptions.privacyToggle ?  'bg-white' : 'bg-gray-300'),
                        (verified.value ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full transition-colors ease-in-out duration-200 my-0 py-0'),
                        (privacyError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[54] || (_cache[54] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass([formData.formSelectionOptions.privacyToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.privacyToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass([formData.formSelectionOptions.privacyToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [54]
                    }, 8, ["modelValue", "disabled", "class"])
                  ])
                ], 2),
                (isNbnService.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["flex transition duration-200 justify-between items-center rounded-lg py-6 px-2 md:px-6", [formData.formSelectionOptions.additionalFeesToggle ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white' : 'border-solid border-black border text-black']])
                    }, [
                      _createElementVNode("div", _hoisted_67, [
                        _cache[55] || (_cache[55] = _createTextVNode(" I understand that additional fees may apply to my service and will be charged to me where applicable, as outlined in the ")),
                        _createElementVNode("a", {
                          href: cisUrl.value,
                          target: "_blank",
                          class: _normalizeClass(["underline transition duration-250 font-bold", [formData.formSelectionOptions.additionalFeesToggle ? 'text-white' : 'text-black']])
                        }, "Critical Information Summary", 10, _hoisted_68),
                        _cache[56] || (_cache[56] = _createTextVNode(". "))
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_unref(Switch), {
                          modelValue: formData.formSelectionOptions.additionalFeesToggle,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.formSelectionOptions.additionalFeesToggle) = $event)),
                          disabled: verified.value,
                          class: _normalizeClass([
                        (formData.formSelectionOptions.additionalFeesToggle ?  'bg-white' : 'bg-gray-300'),
                        (verified.value ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-1 border-transparent rounded-full transition-colors ease-in-out duration-200 my-0 py-0'),
                        (additionalFeesError.value ? 'ring-1 ring-offset-1 ring-brand-primary' : 'focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-brand-primary')
                        ])
                        }, {
                          default: _withCtx(() => [
                            _cache[57] || (_cache[57] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass([formData.formSelectionOptions.additionalFeesToggle ? 'translate-x-4 bg-brand-primary' : 'translate-x-0 bg-white', 'pointer-events-none relative inline-block h-5 w-5 rounded-full  shadow transform ring-0 transition ease-in-out duration-200 -ml-1'])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([formData.formSelectionOptions.additionalFeesToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                                "aria-hidden": "true"
                              }, null, 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([formData.formSelectionOptions.additionalFeesToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition']),
                                "aria-hidden": "true"
                              }, null, 2)
                            ], 2)
                          ]),
                          _: 1,
                          __: [57]
                        }, 8, ["modelValue", "disabled", "class"])
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _cache[61] || (_cache[61] = _createElementVNode("div", null, null, -1)),
        (!verified.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
              _createVNode(AsyncButton, {
                onOnClick: handleContactInformation,
                class: ""
              }, {
                default: _withCtx(() => _cache[59] || (_cache[59] = [
                  _createTextVNode("Confirm Contact Information")
                ])),
                _: 1,
                __: [59]
              }),
              (confirmAddressError.value || termsAgreementError.value || ddAgreementError.value || csgWaiverError.value || privacyError.value || additionalFeesError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_71, " Please confirm your details and tick the required fields "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (verified.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _createVNode(AsyncButton, {
                onOnClick: editDetails,
                class: ""
              }, {
                default: _withCtx(() => _cache[60] || (_cache[60] = [
                  _createTextVNode("Edit Details")
                ])),
                _: 1,
                __: [60]
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_Transition, { name: "fade-scale" }, {
        default: _withCtx(() => [
          (_ctx.otpStep === 2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "otpStepRef",
                ref: otpStepRef,
                class: "fixed inset-0 z-50 flex items-center justify-center"
              }, [
                _createElementVNode("div", {
                  class: "absolute inset-0 bg-black/40",
                  onClick: closeOtp
                }),
                _createElementVNode("div", {
                  ref_key: "modalRef",
                  ref: modalRef,
                  class: "relative z-10 w-full max-w-md bg-white rounded-2xl p-6 shadow-xl"
                }, [
                  _createElementVNode("div", _hoisted_73, [
                    _cache[63] || (_cache[63] = _createElementVNode("p", { class: "font-benzin text-black text-2xl tracking-normal font-normal py-0 my-0" }, [
                      _createTextVNode("VERIFY YOUR"),
                      _createElementVNode("span", { class: "text-brand-primary" }, " PHONE NUMBER")
                    ], -1)),
                    (!verified.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createVNode(OtpVerification, {
                            "phone-number": formData.phoneNumber?.toString(),
                            purpose: "phone_verification",
                            active: _ctx.otpStep === 2,
                            onVerified: handleVerified
                          }, null, 8, ["phone-number", "active"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_75, _cache[62] || (_cache[62] = [
                          _createElementVNode("h2", { class: "text-xl font-semibold text-green-600 font-poppins" }, " Phone verified successfully ", -1)
                        ]))),
                    _createElementVNode("button", {
                      class: "flex-1 bg-red-600 text-white py-2.5 rounded-xl font-medium hover:bg-red-700",
                      onClick: closeOtp
                    }, " Cancel ")
                  ])
                ], 512)
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (verified.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "paymentStep",
            ref: paymentStep,
            class: "grid grid-cols-1 md:grid-cols-3 z-50 relative pt-6"
          }, [
            _cache[64] || (_cache[64] = _createElementVNode("div", { class: "my-6 md:my-12" }, [
              _createElementVNode("hr")
            ], -1)),
            _createElementVNode("div", _hoisted_76, [
              _createVNode(StepGuide, { "current-step": 6 })
            ])
          ], 512))
        : _createCommentVNode("", true),
      (verified.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_78, [
                _cache[70] || (_cache[70] = _createElementVNode("label", {
                  for: "paymentMethodOptions",
                  class: "text-2xl font-poppins-bold text-black"
                }, "Choose your payment method", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "paymentMethodOptions",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.formSelectionOptions.paymentMethod) = $event)),
                  class: "block mt-2 font-poppins w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none",
                  onChange: handleActivationDate
                }, _cache[65] || (_cache[65] = [
                  _createElementVNode("option", { value: 'cc' }, "Credit Card", -1),
                  _createElementVNode("option", { value: 'dd' }, "Bank Account", -1)
                ]), 544), [
                  [_vModelSelect, formData.formSelectionOptions.paymentMethod]
                ]),
                _cache[71] || (_cache[71] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Enter your Details", -1)),
                (!directDebitFormFields.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _cache[66] || (_cache[66] = _createElementVNode("label", { class: "block text-sm font-bold text-black" }, "Card Details", -1)),
                      (monoovaLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, " Loading secure payment form... "))
                        : (!monoovaSessionActive.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "mt-2 px-6 py-2 rounded-full bg-black text-white text-sm font-bold disabled:opacity-50 disabled:cursor-not-allowed",
                              disabled: !monoovaReady.value,
                              onClick: ensureMonoovaCheckout
                            }, " Enter Card Details ", 8, _hoisted_81))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        ref_key: "monoovaContainer",
                        ref: monoovaContainer,
                        class: "w-full mt-2"
                      }, null, 512),
                      (monoovaError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                            _createElementVNode("p", _hoisted_83, _toDisplayString(monoovaError.value), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "underline text-sm mt-1",
                              onClick: retryMonoovaCheckout
                            }, " Try again ")
                          ]))
                        : _createCommentVNode("", true),
                      (cardEntryError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_84, " Please enter your card details "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (directDebitFormFields.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _cache[67] || (_cache[67] = _createElementVNode("label", {
                          for: "account-name",
                          class: "block text-sm font-bold text-black"
                        }, "Account Name", -1)),
                        _createElementVNode("div", _hoisted_87, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "account-name",
                            id: "account-number",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.ddAccountName) = $event)),
                            onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountName.$touch && _unref(v$).ddAccountName.$touch(...args))),
                            class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                          }, null, 544), [
                            [_vModelText, formData.ddAccountName]
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: error.$uid,
                            class: "mt-2 text-sm text-red-600",
                            id: "ddAccountName-error"
                          }, [
                            (error.$property === 'ddAccountName')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(error.$message), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _cache[68] || (_cache[68] = _createElementVNode("label", {
                          for: "account-number",
                          class: "block text-sm font-bold text-black"
                        }, "Account Number", -1)),
                        _createElementVNode("div", _hoisted_90, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "account-number",
                            id: "account-number",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.ddAccountNumber) = $event)),
                            onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountNumber.$touch && _unref(v$).ddAccountNumber.$touch(...args))),
                            class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                          }, null, 544), [
                            [_vModelText, formData.ddAccountNumber]
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: error.$uid,
                            class: "mt-2 text-sm text-red-600",
                            id: "ddAccountNumber-error"
                          }, [
                            (error.$property === 'ddAccountNumber')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(error.$message), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", null, [
                        _cache[69] || (_cache[69] = _createElementVNode("label", {
                          for: "bsb",
                          class: "block text-sm font-bold text-black"
                        }, "BSB", -1)),
                        _createElementVNode("div", _hoisted_92, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "bsb",
                            id: "bsb",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.ddAccountBsb) = $event)),
                            onBlur: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountBsb.$touch && _unref(v$).ddAccountBsb.$touch(...args))),
                            class: "block w-full rounded-full shadow-sm sm:text-sm bg-gray-200 border-none"
                          }, null, 544), [
                            [_vModelText, formData.ddAccountBsb]
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: error.$uid,
                            class: "mt-2 text-sm text-red-600",
                            id: "ddAccountBsb-error"
                          }, [
                            (error.$property === 'ddAccountBsb')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(error.$message), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_94, [
              _cache[73] || (_cache[73] = _createElementVNode("h2", { class: "text-2xl font-poppins-bold text-black" }, "Order Summary", -1)),
              _createElementVNode("div", _hoisted_95, [
                _createVNode(OrderSummary, {
                  products: _ctx.products,
                  isPromoValid: isPromoValid.value,
                  promotionDiscounts: _ctx.promotionDiscounts,
                  validPromotion: _ctx.validPromotion,
                  suggestedPromotion: _ctx.suggestedPromotion,
                  promoCode: _ctx.promoCode,
                  onOnEnterPromoCode: _cache[29] || (_cache[29] = (code) => emit('onEnterPromoCode', code))
                }, null, 8, ["products", "isPromoValid", "promotionDiscounts", "validPromotion", "suggestedPromotion", "promoCode"]),
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(AsyncButton, {
                    onOnClick: handleConfirmOrder,
                    class: "pr-6 w-full"
                  }, {
                    default: _withCtx(() => _cache[72] || (_cache[72] = [
                      _createTextVNode("Confirm Order")
                    ])),
                    _: 1,
                    __: [72]
                  }),
                  _createElementVNode("div", _hoisted_97, [
                    (confirmAddressError.value || termsAgreementError.value || ddAgreementError.value || csgWaiverError.value || privacyError.value || additionalFeesError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_98, " Please confirm your details and tick the required fields "))
                      : _createCommentVNode("", true),
                    (_unref(v$).$error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_99, " Please fill out all required form fields "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: error,
                        class: "mt-4 text-sm text-red-600"
                      }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})